import React, { useState, useEffect, useContext, useMemo, useRef, useLayoutEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import Swal from "sweetalert2";
import NoIndex from "../NoIndex";
import { X, Eye, Pencil } from "lucide-react";
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";
import { Form, FormControl, Modal } from "react-bootstrap";
import CatalogueItemModal from "./Catalogue Components/CatalogueItemModal";
import VariantManagerModal from "./Catalogue Components/VariantManagerModal";
import CatalogueCustomizationModal from "./Catalogue Components/CatalogueCustomizationModal";
import AddPrinterModal from "./Catalogue Components/AddPrinterModal";
import rightArrow from "../../images/Arrow - Right.svg";
import downArrow from "../../images/Arrow - Down.svg";
import "./CatalogueTable.css";
import MyContext from "../../MyContext"; //using ContextAPI to store data dynamically
import { useNavigate } from "react-router-dom";
import AddItemVariantModal from "./Catalogue Components/AddItemVariantModal";
import VariantStockVisibilityModal from "./Catalogue Components/VariantStockVisibilityModal";



// Predefined customization sets
const customizationSets = [
  {
    customize_field: "Sweetness",
    options: ["Less Sweet", "Sweet", "High Sweet"],
  },
  {
    customize_field: "Spice Level",
    options: ["Mild", "Medium", "Spicy"],
  },
  {
    customize_field: "Oil Preference",
    options: ["Low Oil", "Normal Oil", "Extra Oil"],
  },
  {
    customize_field: "Butter Topping",
    options: ["No Butter", "Butter", "Extra Butter"],
  },
  {
    customize_field: "Cooking Type",
    options: ["Fried", "Grilled", "Steamed"],
  },
  {
    customize_field: "Onion & Garlic",
    options: ["No Onion", "No Garlic"],
  },
];

const CatalogueTable = ({ userID }) => {
  const { baseUrl } = useContext(MyContext);
  const { config } = useContext(MyContext);
  const [loading, setLoading] = useState(false);
  const [catalogueStore, setCatalogueStore] = useState([]);

  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");
  const [activeTab, setActiveTab] = useState("catalogue");

  const [isVariantModalOpen, setIsVariantModalOpen] = useState(false);


  const [expandedCategories, setExpandedCategories] = useState([]);

  const [loadingVariants, setLoadingVariants] = useState(false);
  const [variants, setVariants] = useState([]);

  const [customizationModal, setCustomizationModal] = useState(null);

  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [preSelectedCustomizaton, setPreSelectedCustomizaton] = useState(null);

  const [selectedCustomizations, setSelectedCustomizations] = useState([]);
  const [availabilityData, setAvailabilityData] = useState({});
  const [viewModalItem, setViewModalItem] = useState(null);
  const [viewModalTab, setViewModalTab] = useState("details");
  const [printerList, setPrinterList] = useState([]);
  const [printerLoading, setPrinterLoading] = useState(false);
  const [selectedPrinter, setSelectedPrinter] = useState(null);
  const [isEditingDetails, setIsEditingDetails] = useState(false);
  const [editableDetails, setEditableDetails] = useState({});
  const [showAddItemVariantModal, setShowAddItemVariantModal] = useState(false);
  const [selectedVariantItem, setSelectedVariantItem] = useState(null);
  const [variantSVModalOpen, setVariantSVModalOpen] = useState(false);
  const [variantSVItem, setVariantSVItem] = useState(null);

  const anchorRef = useRef(null);
  // anchorRef.current = { catId: "353", itemId: "16086" }

  const markAnchor = (catId, itemId) => {
    anchorRef.current = { catId: String(catId), itemId: String(itemId) };
  };

  const didSetDefaultOpenRef = useRef(true);


  // Prevent number inputs from changing on scroll (trackpad / mouse wheel)
  const handleNumberWheel = (e) => {
    e.target.blur();
  };
  const handleItemUpdated = () => {
    allcatalogueAPI(true);
  };

  const handleCheckboxChange = (itemId, field) => {
    setAvailabilityData((prev) => ({
      ...prev,
      [itemId]: {
        ...prev[itemId],
        [field]: !prev[itemId][field],
      },
    }));
  };

  const handleSubmit = async (e, itemId) => {
    e.preventDefault();
    const updated = availabilityData[itemId];

    try {
      const requestBody = {
        userid: userID,
        itemId: itemId,
        homeDelivery: updated.homeDelivery,
        takeaway: updated.takeaway,
        dining: updated.dineIn,
      };

      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/changeItemAvailability`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {
        toast.success(
          response?.data?.responseMessage || "Status updated successfully!"
        );
        await allcatalogueAPI();
      } else {
        Swal.fire({
          title: "Error",
          text: response.data.responseMessage || "Something went wrong.",
          icon: "error",
          confirmButtonText: "Okay",
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: "An error occurred while processing your request.",
        icon: "error",
        confirmButtonText: "Okay",
      });
    }
  };

  const allcatalogueAPI = async (preserveScroll = false) => {
    const currentScrollY = preserveScroll ? window.scrollY || 0 : null;

    setLoading(true);
    try {
      const requestBody = {
        userid: userID,
        secret: "string",
      };
      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/getCatalogueItemsMaster`,
        requestBody,
        config
      );
      console.log(response.data.response);
      if (response.data.responseCode === "00") {
        setCatalogueStore(response.data.response);
      }
    } catch {
    } finally {
      setLoading(false);
      if (preserveScroll && currentScrollY !== null) {
        window.scrollTo({ top: currentScrollY, behavior: "auto" });
      }
    }
  };
  // Refresh catalogue but keep current scroll position
  const refreshCataloguePreserveScroll = async () => {
    const currentScrollY = window.scrollY || 0;
    await allcatalogueAPI();
    window.scrollTo({ top: currentScrollY, behavior: "auto" });
  };


  useEffect(() => {
    allcatalogueAPI();
    fetchVariants();
  }, []);
  const fetchVariants = async () => {
    setLoadingVariants(true);
    try {
      const requestBody = {
        userid: userID,
        secret: "string",
      };
      const response = await axios.post(
        `${baseUrl}/api/Inventory/v1.0/getAllInventoryVariant`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {
        const list = (response.data.response || []).map((r) => ({
          id: String(r.pk_variant_id ?? r.variantId ?? r._id ?? ""),
          variant_title: r.variant_title ?? r.variantTitle ?? "",
          category: r.category ?? "",
        }));
        setVariants(list);
      } else {
        setVariants([]);
      }
    } catch {
      setVariants([]);
    } finally {
      setLoadingVariants(false);
    }
  };


  const [searchTerm, setSearchTerm] = useState(""); // Add state for search term
  // Filter the catalogue based on search term
  const filteredCatalogue = catalogueStore.filter((item) =>
    searchTerm.trim() === "" // If search box is empty, show full list
      ? true
      : item.title?.toLowerCase().includes(searchTerm.toLowerCase()) // Case-insensitive filter
  );



  const toggleCategory = (catId) => {
    setExpandedCategories((prev) =>
      prev.includes(catId) ? prev.filter((id) => id !== catId) : [...prev, catId]
    );
  };

  const filteredCategories = useMemo(() => {
    if (!catalogueStore) return [];
    return catalogueStore
      .map((category) => {
        const filteredItems = (category.menu_items || []).filter((item) => {
          const matchesSearch = item?.item_name
            ?.toLowerCase()
            .includes(searchText.toLowerCase());
          if (!matchesSearch) return false;

          const prices = Array.isArray(item.prices) ? item.prices : [];
          const firstPrice = prices.length > 0 ? prices[0] : {};
          const visibilitySource =
            item.visibility ?? firstPrice.visibility;

          const isVisible =
            visibilitySource === "Y" ||
            visibilitySource === true ||
            visibilitySource === 1 ||
            visibilitySource === "1";

          const isOutOfStockOrInvisible = !item.inStock || !isVisible;

          if (activeTab === "out-of-stock") {
            return isOutOfStockOrInvisible;
          }

          // activeTab === "catalogue" -> show all items (matching search) regardless of stock/visibility
          return true;
        });

        return {
          ...category,
          menu_items: filteredItems,
        };
      })
      .filter((category) => category.menu_items.length > 0);
  }, [catalogueStore, searchText, activeTab]);

  useEffect(() => {
    // If anchor restore is pending, don't fight it
    if (anchorRef.current) return;

    // If searching: expand only matched categories
    if (searchText.trim()) {
      const matchedIds = filteredCategories.map((cat) => String(cat.cat_id));
      setExpandedCategories(matchedIds);
      return;
    }

    // No search: set default open only ONCE after first load
    if (!didSetDefaultOpenRef.current && catalogueStore.length > 0) {
      didSetDefaultOpenRef.current = true;
      const firstCatId = String(catalogueStore[0].cat_id);
      setExpandedCategories([firstCatId]);
    }
  }, [filteredCategories, searchText, catalogueStore]);

  const toggleStockStatus = async (item) => {
    const newStatus = item.inStock ? "N" : "Y";

    const prices = Array.isArray(item.prices) ? item.prices : [];
    const firstPrice = prices.length > 0 ? prices[0] : {};
    const visibilitySource = item.visibility ?? firstPrice.visibility;

    const isVisible =
      visibilitySource === "Y" ||
      visibilitySource === true ||
      visibilitySource === 1 ||
      visibilitySource === "1";

    try {
      const requestBody = {
        userid: userID,
        id: item.item_id,
        stock: "1",
        inStock: newStatus,
        isVisible: isVisible ? "Y" : "N",
        type: "item",
      };

      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/updateStock`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {
        toast.success(
          response?.data?.responseMessage || "Status updated successfully!"
        );
        await allcatalogueAPI();
      } else {
        Swal.fire({
          title: "Error",
          text: response.data.responseMessage || "Something went wrong.",
          icon: "error",
          confirmButtonText: "Okay",
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: "An error occurred while processing your request.",
        icon: "error",
        confirmButtonText: "Okay",
      });
    }
  };


  // Open customization modal for an item
  const openCustomizationModal = (item, preSelected) => {
    setSelectedCategoryId(item);
    setCustomizationModal(true);

    // Parse preSelected (it could be a string or object)
    let parsed = [];
    try {
      if (typeof preSelected === "string") {
        parsed = JSON.parse(preSelected || "[]");
      } else if (Array.isArray(preSelected)) {
        parsed = preSelected;
      }
    } catch (err) {
      console.error("Failed to parse preSelected customizations:", err);
    }

    setPreSelectedCustomizaton(parsed);

    // Extract only the customize_field names for pre-checking
    const initiallySelectedFields = parsed.map((c) => c.customize_field);
    setSelectedCustomizations(initiallySelectedFields);
  };

  const handleCustomizationApply = async () => {
    const categoryId = selectedCategoryId; // currently selected category ID

    // selectedCustomizations is now an array of customize_field names, not indexes
    const customizationArray = customizationSets
      .filter((set) => selectedCustomizations.includes(set.customize_field))
      .map((set) => ({
        customization_type: "customize",
        customize_field: set.customize_field,
        options: set.options,
      }));

    const payload = {
      userid: userID,
      id: categoryId,
      customizations: customizationArray,
      type: "category",
      operation: "add",
    };

    try {
      const res = await axios.post(
        `${baseUrl}/api/Order/v1.0/updateCustomization`,
        payload,
        config
      );

      if (res.data.responseCode === "00") {
        toast.success(
          res.data.data.message || "Customization updated successfully"
        );
        await allcatalogueAPI();
      }
      else {
        toast.error(res.data.data.message || "Failed to update customization");
      }
    } catch (err) {
      console.error("Failed to send customization:", err);
      toast.error("Something went wrong while updating customization");
    }

    setCustomizationModal(false);
  };

  const [addPrinterModalOpen, setAddPrinterModalOpen] = useState(false);
  const [addPrinterFormData, setAddPrinterFormData] = useState({
    printerName: "",
    printerAlias: "",
    deviceName: "",
    deviceNumber: "",
  });

  const handlePrinterInputChange = (e) => {
    setAddPrinterFormData({
      ...addPrinterFormData,
      [e.target.name]: e.target.value,
    });
  };

  const handleAddPrinterSubmit = async () => {
    const payload = {
      userid: String(userID),
      ...addPrinterFormData,
    };

    try {
      const res = await fetch(`${baseUrl}/api/Order/v1.0/addPrinter`, {
        method: "POST",
        headers: {
          ...config.headers,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();
      if (data.responseCode === "00") {
        Swal.fire("Success", data.responseMessage, "success");
        setAddPrinterModalOpen(false);
        setAddPrinterFormData({
          printerName: "",
          printerAlias: "",
          deviceName: "",
          deviceNumber: "",
        });
      } else {
        Swal.fire("Error", data.responseMessage, "error");
      }
    } catch (error) {
      Swal.fire("Error", "Something went wrong", "error");
    }
  };

  const fetchPrinterList = async () => {
    try {
      setPrinterLoading(true);
      const res = await axios.post(
        `${baseUrl}/api/Order/v1.0/getPrinters`,
        {
          userid: userID,
        },
        config
      );

      if (res.data.responseCode === "00") {
        setPrinterList(res.data.response || []);
      } else {
        toast.error("Failed to load printers");
      }
    } catch (err) {
      toast.error("Error fetching printers");
    } finally {
      setPrinterLoading(false);
    }
  };

  const handleSavePrinterToItem = async () => {
    if (!selectedPrinter) return toast.error("Please select a printer first");

    try {
      const payload = {
        userid: userID,
        itemId: viewModalItem.item_id,
        printerCode: selectedPrinter?.printerCode,
        printerAlias: selectedPrinter?.printerAlias,
      };

      const res = await axios.post(
        `${baseUrl}/api/Order/v1.0/addPrinterCodeToItem`,
        payload,
        config
      );

      if (res.data.responseCode === "00") {
        Swal.fire("Success", res.data.responseMessage, "success");
      } else {
        Swal.fire("Error", res.data.responseMessage, "error");
      }
    } catch (err) {
      Swal.fire("Error", "Something went wrong", "error");
    }
  };


  const handleUpdateItem = async () => {
    try {
      const payload = {
        userid: String(userID),
        itemId: editableDetails.item_id,
        itemName: editableDetails.item_name,
        sizeId: String(editableDetails.sizeId || ""),
        category: String(editableDetails.category || ""),
        size: String(editableDetails.size || ""),
        sellingPrice: String(editableDetails.sellingPrice || ""),
        // NEW extended fields
        homeDeliveryPrice: String(editableDetails.homeDeliveryPrice ?? ""),
        takewayPrice: String(editableDetails.takewayPrice ?? ""),
        diningPrice: String(editableDetails.diningPrice ?? ""),
        roomOrderPrice: String(editableDetails.roomOrderPrice ?? ""),
        carOrderPrice: String(editableDetails.carOrderPrice ?? ""),
        taxPercentage: String(editableDetails.taxPercentage ?? ""),
      };

      const res = await axios.post(
        `${baseUrl}/api/Order/v1.0/updateCatalogItems`,
        payload,
        config
      );

      if (res.data.responseCode === "00") {
        toast.success(
          res.data.responseMessage || "Item updated successfully"
        );
        setIsEditingDetails(false);
        await allcatalogueAPI(true); // 🔹 preserve scroll & open category
        await allcatalogueAPI();
      } else {
        Swal.fire(
          "Error",
          res.data.responseMessage || "Update failed",
          "error"
        );
      }
    } catch (err) {
      Swal.fire("Error", "Something went wrong", "error");
    }
  };

  const toggleVisibilityStatus = async (item) => {
    const prices = Array.isArray(item.prices) ? item.prices : [];
    const firstPrice = prices.length > 0 ? prices[0] : {};
    const visibilitySource = item.visibility ?? firstPrice.visibility;

    const isCurrentlyVisible =
      visibilitySource === "Y" ||
      visibilitySource === true ||
      visibilitySource === 1 ||
      visibilitySource === "1";

    const newVisibility = isCurrentlyVisible ? "N" : "Y";
    const currentInStockYN = item.inStock ? "Y" : "N";

    try {
      const requestBody = {
        userid: userID,
        id: item.item_id,
        type: "item",
        stock: "1",
        inStock: currentInStockYN,
        isVisible: newVisibility,
      };

      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/updateStock`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {
        toast.success(
          response?.data?.responseMessage || "Visibility updated!"
        );
        await allcatalogueAPI();
      } else {
        Swal.fire({
          title: "Error",
          text: response.data.responseMessage || "Something went wrong.",
          icon: "error",
          confirmButtonText: "Okay",
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: "An error occurred while processing your request.",
        icon: "error",
        confirmButtonText: "Okay",
      });
    }
  };

  const ResetStock = async () => {
    try {
      setPrinterLoading(true);
      const res = await axios.post(
        `${baseUrl}/api/Order/v1.0/resetStock`,
        {
          userid: userID,
        },
        config
      );

      if (res.data.responseCode === "00") {
        setPrinterList(res.data.response || []);
        toast.success(res.data.responseMessage)
      } else {
        toast.error("Failed to load printers");
      }
    } catch (err) {
      toast.error("Error fetching printers");
    } finally {
      setPrinterLoading(false);
    }
  };
  useLayoutEffect(() => {
    const anchor = anchorRef.current;
    if (!anchor) return;

    // 1) Make sure the category is expanded
    setExpandedCategories((prev) => {
      const catId = anchor.catId;
      return prev.includes(catId) ? prev : [...prev, catId];
    });

    // 2) Scroll to the item after DOM is painted
    requestAnimationFrame(() => {
      const el = document.getElementById(`cat-item-${anchor.itemId}`);
      if (el) {
        el.scrollIntoView({ block: "center", behavior: "smooth" });
      }
    });

    // 3) Clear anchor so it doesn't keep scrolling forever
    anchorRef.current = null;
  }, [catalogueStore]);
  useEffect(() => {
    if (!catalogueStore?.length) return;

    setAvailabilityData((prev) => {
      const next = { ...prev };

      for (const category of catalogueStore) {
        for (const item of (category.menu_items || [])) {
          if (!next[item.item_id]) {
            next[item.item_id] = {
              homeDelivery: item.homeDeliveryAvailability,
              takeaway: item.takeawayAvailability,
              dineIn: item.diningAvailability,
            };
          }
        }
      }

      return next;
    });
  }, [catalogueStore]);



  return (
    <>
      <>
        <NoIndex />
        <div className="d-flex justify-content-center text-center">
          <ToastContainer />
        </div>
        <div
          className="p-4 bg-white"
          style={{
            fontFamily: "Nunito, sans-serif",
          }}
        >


          <div className="bg-white px-4">
            <div className="  " style={{ borderRadius: "10px" }}>
              <div className="d-flex justify-content-between pb-2">
                <div className="CreateCampaign p-0 m-0">Catalogue Items </div>
                <div className="d-flex justify-content-between">
                  <Form className="">
                    <FormControl
                      type="text"
                      placeholder="Search"
                      className="bg-light"
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                    />
                  </Form>
                  <div></div>
                  <div>
                    <button
                      className="btn btn-primary single-line-css ms-3"
                      onClick={() => navigate("/Orders/Catalogue/add-items")}
                    >
                      Add Items
                    </button>

                    <button
                      className="btn btn-success single-line-css ms-3"
                      onClick={() => setIsVariantModalOpen(true)}
                    >
                      Add Varients
                    </button>

                    <button
                      className="blue-button single-line-css ms-3"
                      onClick={() => setAddPrinterModalOpen(true)}
                    >
                      Add Printer
                    </button>

                    <button
                      className="btn btn-danger single-line-css ms-3"
                      onClick={() => ResetStock()}
                    >
                      Reset Stock
                    </button>
                  </div>

                </div>
              </div>

              <div className="mt-3">
                <div
                  className="btn-group"
                  role="group"
                  aria-label="Catalogue tabs"
                >
                  <button
                    type="button"
                    className={`btn btn-sm ${activeTab === "catalogue"
                      ? "btn-primary"
                      : "btn-outline-primary"
                      }`}
                    onClick={() => setActiveTab("catalogue")}
                  >
                    Catalogue
                  </button>
                  <button
                    type="button"
                    className={`btn btn-sm ${activeTab === "out-of-stock"
                      ? "btn-primary"
                      : "btn-outline-primary"
                      }`}
                    onClick={() => setActiveTab("out-of-stock")}
                  >
                    Out of Stock
                  </button>
                </div>
              </div>

              {loading ? (
                <div className=" m-5 p-5 d-flex justify-content-center">
                  <div className="loader "></div>
                </div>
              ) : (
                <>
                  <div className="p-0 m-0 pb-12">
                    <div className=" bg-gray-10 rounded p-1"></div>
                    {filteredCategories.map((category) => {
                      const catId = String(category.cat_id);
                      const isExpanded = expandedCategories.includes(catId);

                      const itemsToShow = isExpanded
                        ? category.menu_items
                        : category.menu_items.slice(0, 0);

                      // itemsToShow.forEach((item) => {
                      //   if (!availabilityData[item.item_id]) {
                      //     setAvailabilityData((prev) => ({
                      //       ...prev,
                      //       [item.item_id]: {
                      //         homeDelivery: item.homeDeliveryAvailability,
                      //         takeaway: item.takeawayAvailability,
                      //         dineIn: item.diningAvailability,
                      //       },
                      //     }));
                      //   }
                      // });

                      return (
                        <div key={catId}>
                          <div className="d-flex justify-content-between align-items-center my-3">
                            <p
                              className="fw-bold text-dark cursor-pointer"
                              style={{ cursor: "pointer" }}
                              onClick={() => toggleCategory(catId)}
                            >
                              {category.category_name?.length > 20
                                ? category.category_name
                                : category.category_name}
                            </p>

                            <div className="d-flex justify-content-end gap-3">
                              <button
                                className="btn btn-sm ms-3 fw-semibold shadow-sm"
                                style={{
                                  backgroundColor: "rgba(1, 195, 125, 1)",
                                  borderColor: "rgba(1, 195, 125, 1)",
                                  color: "white",
                                  transition: "all 0.2s ease-in-out",
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.backgroundColor =
                                    "rgba(1, 180, 115, 1)";
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.backgroundColor =
                                    "rgba(1, 195, 125, 1)";
                                }}
                                onClick={() =>
                                  openCustomizationModal(
                                    catId,
                                    category.customization
                                  )
                                }
                              >
                                Customize
                              </button>
                              {category.menu_items.length > 0 && (
                                <button
                                  className="btn btn-sm px-2 py-1 rounded bg-light text-primary"
                                  onClick={() => toggleCategory(catId)}
                                >
                                  {isExpanded ? (
                                    <img
                                      src={downArrow}
                                      className="img-fluid"
                                      style={{ width: "1rem", height: "1rem" }}
                                      alt=""
                                    />
                                  ) : (
                                    <img
                                      src={rightArrow}
                                      className="img-fluid"
                                      style={{ width: "1rem", height: "1rem" }}
                                      alt=""
                                    />
                                  )}
                                </button>
                              )}
                            </div>
                          </div>

                          <div className="ps-1">
                            {itemsToShow.map((item) => {
                              const hasVariants =
                                Array.isArray(item.prices) && item.prices.length > 1;
                              const firstPrice =
                                Array.isArray(item.prices) &&
                                  item.prices.length > 0
                                  ? item.prices[0]
                                  : {};
                              const visibilitySource =
                                item.visibility ?? firstPrice.visibility;
                              const isVisible =
                                visibilitySource === "Y" ||
                                visibilitySource === true ||
                                visibilitySource === 1 ||
                                visibilitySource === "1";

                              return (
                                <div
                                  key={item.item_id}
                                  id={`cat-item-${item.item_id}`}
                                  className="d-flex align-items-center  py-2 bg-light rounded my-2"
                                >
                                  {/* Image */}
                                  <div
                                    className="flex-shrink-0 ms-2"
                                    style={{
                                      width: "5rem",
                                      height: "5rem",
                                      borderRadius: "10px",
                                      overflow: "hidden",
                                    }}
                                  >
                                    <img
                                      src={item.photo}
                                      alt={item.name}
                                      loading="lazy"
                                      decoding="async"
                                      className="w-100 h-100 object-fit-cover"
                                    />
                                  </div>

                                  {/* Text Content */}
                                  <div className="flex-grow-1 text-start ms-3">
                                    <p className="fw-medium mb-1 ">
                                      {item.item_name}
                                    </p>
                                    <p className="text-muted small mb-0">
                                      {item.prices?.[0]?.formatted_price}
                                    </p>
                                  </div>
                                  <div className="d-flex flex-wrap align-items-center">
                                    <button
                                      className="bg-success btn btn-sm d-flex align-items-center gap-1 px-3 py-1 border-0"
                                      onClick={() => {
                                        markAnchor(category.cat_id, item.item_id);
                                        let categoryIdFromItem = "";
                                        try {
                                          categoryIdFromItem =
                                            (JSON.parse(item.category || "[]") || [])[0] || "";
                                        } catch {
                                          categoryIdFromItem = item.category || "";
                                        }

                                        const prices = Array.isArray(item.prices) ? item.prices : [];
                                        const first = prices[0] || {};

                                        const parentCategoryId = category.cat_id;          // from parent object
                                        const parentCategoryName = category.category_name; // from parent object

                                        const itemWithParent = {
                                          ...item,
                                          parentCategoryId,
                                          parentCategoryName,
                                        };

                                        setViewModalItem(itemWithParent);

                                        setEditableDetails({
                                          ...itemWithParent,

                                          item_id: item.item_id,
                                          item_name: item.item_name,

                                          // sub-category display
                                          category: item.sub_category || categoryIdFromItem,

                                          // 🔹 store parent category id here
                                          categoryId: String(parentCategoryId || ""),

                                          // image fields
                                          photo: item.photo || "",
                                          imageUrl: item.photo || "",

                                          selectedPriceIndex: 0,
                                          sizeId: first.size_id || "",
                                          size: first.size || "",
                                          sellingPrice: first.price || "",
                                          homeDeliveryPrice:
                                            first.home_delivery_price ??
                                            first.homeDeliveryPrice ??
                                            "",
                                          takewayPrice:
                                            first.takeaway_price ??
                                            first.takewayPrice ??
                                            "",
                                          diningPrice:
                                            first.dining_price ??
                                            first.diningPrice ??
                                            "",
                                          roomOrderPrice:
                                            first.room_order_price ??
                                            first.roomOrderPrice ??
                                            "",
                                          carOrderPrice:
                                            first.car_order_price ??
                                            first.carOrderPrice ??
                                            "",
                                          taxPercentage:
                                            first.item_tax ?? first.taxPercentage ?? "",

                                          rackNo: item.rackNumber || "",
                                          expiryDate: item.expiryDate || "",

                                          // 🔹 base variant info from price row
                                          variantId: String(first.variantId || first.size_id || ""),
                                          variantName: first.variantName || first.size || "",
                                          id: first.id || "",
                                        });

                                        setIsEditingDetails(false);
                                      }}

                                      style={{
                                        fontWeight: 600,
                                        fontSize: "14px",
                                        borderRadius: "999px",
                                        color: "white",
                                      }}
                                    >
                                      <Eye size={16} />
                                      View
                                    </button>
                                    {/* 🔹 New: Add Variant button */}
                                    <button
                                      className="btn btn-sm ms-2 d-flex align-items-center gap-1 px-3 py-1"
                                      style={{
                                        backgroundColor: "#01C37D",
                                        borderColor: "#01C37D",
                                        color: "#FFFFFF",
                                        fontWeight: 600,
                                        fontSize: "14px",
                                        borderRadius: "999px",
                                      }}
                                      onClick={() => {
                                        setSelectedVariantItem(item);
                                        setShowAddItemVariantModal(true);
                                      }}
                                    >
                                      + Variant
                                    </button>
                                  </div>

                                  <div className="d-flex align-items-center p-2 rounded-3">
                                    {hasVariants ? (
                                      <div className="d-flex align-items-center ms-3 p-2 rounded-3">
                                        <button
                                          className="btn btn-sm btn-outline-primary"
                                          onClick={() => {
                                            markAnchor(category.cat_id, item.item_id);
                                            setVariantSVItem(item);
                                            setVariantSVModalOpen(true);
                                          }}
                                        >
                                          Show Variant
                                        </button>
                                         {/* Visibility toggle (existing) */}
                                        <div className="d-flex align-items-center ms-3 p-2 rounded-3">
                                          <div className="me-1">
                                            <span className="">Visible</span>
                                          </div>
                                          <div className="order-switch d-flex align-items-center cursor-pointer">
                                            <label className="order-switch-label mb-0">
                                              <input
                                                type="checkbox"
                                                checked={isVisible}
                                                onChange={() => {
                                                  markAnchor(category.cat_id, item.item_id);
                                                  toggleVisibilityStatus(item);
                                                }}
                                              />
                                              <span
                                                className={`order-slider order-round ms-2 ${isVisible ? "on" : "off"}`}
                                              >
                                                {isVisible ? "Y" : "N"}
                                              </span>
                                            </label>
                                          </div>
                                        </div>

                                        {/* Stock toggle (existing) */}
                                        <div className="d-flex align-items-center ms-3 p-2 rounded-3">
                                          <div className="me-1">
                                            <span className="">In Stock</span>
                                          </div>
                                          <div className="order-switch d-flex align-items-center cursor-pointer">
                                            <label className="order-switch-label mb-0">
                                              <input
                                                type="checkbox"
                                                checked={item.inStock}
                                                onChange={() => {
                                                  markAnchor(category.cat_id, item.item_id);
                                                  toggleStockStatus(item);
                                                }}
                                              />
                                              <span
                                                className={`order-slider order-round ms-2 ${item.inStock ? "on" : "off"}`}
                                              >
                                                {item.inStock ? "ON" : "OFF"}
                                              </span>
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                    ) : (
                                      <>
                                        {/* Visibility toggle (existing) */}
                                        <div className="d-flex align-items-center ms-3 p-2 rounded-3">
                                          <div className="me-1">
                                            <span className="">Visible</span>
                                          </div>
                                          <div className="order-switch d-flex align-items-center cursor-pointer">
                                            <label className="order-switch-label mb-0">
                                              <input
                                                type="checkbox"
                                                checked={isVisible}
                                                onChange={() => {
                                                  markAnchor(category.cat_id, item.item_id);
                                                  toggleVisibilityStatus(item);
                                                }}
                                              />
                                              <span
                                                className={`order-slider order-round ms-2 ${isVisible ? "on" : "off"}`}
                                              >
                                                {isVisible ? "Y" : "N"}
                                              </span>
                                            </label>
                                          </div>
                                        </div>

                                        {/* Stock toggle (existing) */}
                                        <div className="d-flex align-items-center ms-3 p-2 rounded-3">
                                          <div className="me-1">
                                            <span className="">In Stock</span>
                                          </div>
                                          <div className="order-switch d-flex align-items-center cursor-pointer">
                                            <label className="order-switch-label mb-0">
                                              <input
                                                type="checkbox"
                                                checked={item.inStock}
                                                onChange={() => {
                                                  markAnchor(category.cat_id, item.item_id);
                                                  toggleStockStatus(item);
                                                }}
                                              />
                                              <span
                                                className={`order-slider order-round ms-2 ${item.inStock ? "on" : "off"}`}
                                              >
                                                {item.inStock ? "ON" : "OFF"}
                                              </span>
                                            </label>
                                          </div>
                                        </div>
                                      </>
                                    )}
                                  </div>

                                </div>
                              );
                            })}
                            <hr className="border-secondary" />
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
        {/* Customization Modal */}
        <CatalogueCustomizationModal
          show={!!customizationModal}
          onHide={() => setCustomizationModal(false)}
          customizationSets={customizationSets}
          selectedCustomizations={selectedCustomizations}
          setSelectedCustomizations={setSelectedCustomizations}
          onApply={handleCustomizationApply}
        />

        {/* View / Edit Modal */}
        <CatalogueItemModal
          viewModalItem={viewModalItem}
          setViewModalItem={setViewModalItem}
          viewModalTab={viewModalTab}
          setViewModalTab={setViewModalTab}
          editableDetails={editableDetails}
          setEditableDetails={setEditableDetails}
          isEditingDetails={isEditingDetails}
          setIsEditingDetails={setIsEditingDetails}
          handleNumberWheel={handleNumberWheel}
          availabilityData={availabilityData}
          handleCheckboxChange={handleCheckboxChange}
          handleSubmit={handleSubmit}
          printerList={printerList}
          printerLoading={printerLoading}
          fetchPrinterList={fetchPrinterList}
          selectedPrinter={selectedPrinter}
          setSelectedPrinter={setSelectedPrinter}
          setAddPrinterModalOpen={setAddPrinterModalOpen}
          handleSavePrinterToItem={handleSavePrinterToItem}
          navigate={navigate}
          userID={userID}
          baseUrl={baseUrl}
          config={config}
          onItemUpdated={refreshCataloguePreserveScroll}
          variants={variants}                 // 🔹 add
          loadingVariants={loadingVariants}   // 🔹 add
        />

        {/* Add Printer Modal */}
        <AddPrinterModal
          open={addPrinterModalOpen}
          onClose={() => setAddPrinterModalOpen(false)}
          formData={addPrinterFormData}
          onChange={handlePrinterInputChange}
          onSubmit={handleAddPrinterSubmit}
        />
        {/* 🔹 NEW: VariantManagerModal – full CRUD for variants */}
        <VariantManagerModal
          show={isVariantModalOpen}
          onHide={() => setIsVariantModalOpen(false)}
          baseUrl={baseUrl}
          config={config}
          variants={variants}
          loadingVariants={loadingVariants}
          refreshVariants={fetchVariants}
        />
        <AddItemVariantModal
          show={showAddItemVariantModal}
          onHide={() => setShowAddItemVariantModal(false)}
          itemId={selectedVariantItem?.item_id}
          item={selectedVariantItem}
          itemName={selectedVariantItem?.item_name}
          userID={userID}
          baseUrl={baseUrl}
          config={config}
          onSuccess={refreshCataloguePreserveScroll}
        />
        <VariantStockVisibilityModal
          show={variantSVModalOpen}
          onHide={() => {
            setVariantSVModalOpen(false);
            setVariantSVItem(null);
          }}
          item={variantSVItem}
          baseUrl={baseUrl}
          config={config}
          onUpdated={refreshCataloguePreserveScroll}
        />




      </>
    </>
  );
};

export default CatalogueTable;
